import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
interface ParamsCTXRList {
  cloud?: any;
  regions?: any;
}



export function getGraficaDataIn(SuscriptionId:String, CloudAccountId:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/cloud/'+CloudAccountId+'/historicalForOperation')
  }

export function getDataConnector(SuscriptionId:Number,source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/AvailableMonth?source='+source)
  }

export function getDataConnectorGlobal(SuscriptionId:Number,tenant:number,source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/AvailableMonth?tenantId='+tenant+'&source='+source)
  }

export function getCTXRStatus (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusctxr')
  }

export function getCTXRStatusGlobal (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusctxr?tenantId='+tenant)
  }

export function getInstances (SuscriptionId:Number, source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances?source='+source)
  }

export function getInstancesGlobales (SuscriptionId:Number,tenant:number,source:string) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances?tenantId='+tenant+'&source='+source)
  }

export function getStatusSesiones (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances/-1/ShowBGPSummary')
  }
export function getStatusSesionesglobales (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/instances/-1/ShowBGPSummary?tenantId='+tenant)
  }
//////////////////////////
export function getCTXNeighborstatus (SuscriptionId:Number,signal:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusneighbor/',signal);
  }
  ///////////////////////////////
export function getCTXNeighborstatusGlobal (SuscriptionId:Number, tenant:number,signal:any) {
    return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/statusneighbor?tenantId='+tenant,signal);
  }

export function getCloudStatus (SuscriptionId:Number,Type:String,nameregion:String) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?type='+Type+'&region='+nameregion)
  }

export function getCloudStatusGlobal (SuscriptionId:Number,Type:String,nameregion:String,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?type='+Type+'&region='+nameregion+'&tenantId='+tenant)
  }

export function getCloudsStatus (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth')
  }

export function getCloudsStatusG (SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CloudHealth?tenantId='+tenant)
  }

export function getTopology (SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/topology')
  }

export function getsuscription () {
    return axios.get(API_URL+'/v1/suscription')
  }

export function getsuscriptionglobal (tenant:number) {
    return axios.get(API_URL+'/v1/suscription?tenantId='+tenant)
  }

  
export function getConnectors(SuscriptionId:number) {
  return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/connector')
}

export function getCTXRlist(SuscriptionId:number,cloud?:any,region?:any) {
  const params: ParamsCTXRList = {};

  if (cloud !== undefined) {
    params.cloud = cloud;
  }

  if (region !== undefined) {
    params.regions = region;
  }
  return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/listSelector',{params})
}

export function getCTXRlistGlobal(SuscriptionId:number,tenant:number,cloud?:any,region?:any) {
  const params: ParamsCTXRList = {};

  if (cloud !== undefined) {
    params.cloud = cloud;
  }

  if (region !== undefined) {
    params.regions = region;
  }
  return axios.get(API_URL+'/v1/ctxr/'+SuscriptionId+'/listSelector?tenantId='+tenant,{params:{cloud,region}})
}
